var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6932 0.871094V46.8711L0.414551 0.871094H45.6932Z",
    fill: "#FFF7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4331 6.87109H39.4331V23.8711L34.3081 18.8086L29.4331 23.8711V6.87109Z",
    stroke: "#B1924C",
    fill: "inherit",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertBookmark);
export default __webpack_public_path__ + "static/media/advert-bookmark.14454f6545f65e5f7d2ce84e0123e436.svg";
export { ForwardRef as ReactComponent };